import React, { useEffect, useState } from 'react';
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {SettingsState} from "../../../store/settings/types";
import MyDate from "../../../utils/MyDate";


interface Props {
    className: string
}

const ClockComponent: React.FC<Props> = ({className}) => {
    const [time, setTime] = useState(new MyDate());
    const { isLocalTime, timeZone } = useSelector<ApplicationState, SettingsState>(state => state.settings);

    useEffect(() => {
        const timerID = setInterval(
            () => setTime(new MyDate()),
            1000
        );

        return () => clearInterval(timerID)
    }, []);

    return (
        <span className={className}>
            {
                timeZone === 'UTC' 
                    ? isLocalTime 
                        ? time.to12UTCTime()
                        : time.to24UTCTime()
                    : isLocalTime 
                        ? time.toLocaleTimeString() 
                        : time.to24TimeString()
            }
        </span>
    );
};

export default ClockComponent;